import ModuleView from "./ModuleView";

export default ModuleView;
